import { Divider } from "primereact/divider"

export const InformacaoQuod = () => {
    return (
        <div>
        <Divider className="automotiva" />
      </div>
    )
}